import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { Award, Zap, BarChart2, Headphones } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Certified Coding Staff',
      description: 'AAPC/CPC certified coders with specialized healthcare expertise ensuring accuracy and compliance.',
    },
    {
      icon: Zap,
      title: 'Seamless EHR Integration',
      description: 'Compatible with Epic, athenahealth, eClinicalWorks, AdvancedMD, and all major practice management systems.',
    },
    {
      icon: BarChart2,
      title: 'Real-Time Reporting Dashboard',
      description: 'Complete transparency with live dashboards showing claims status, AR aging, and revenue metrics.',
    },
    {
      icon: Headphones,
      title: 'Dedicated Account Manager',
      description: 'Your personal point of contact who knows your practice and is available whenever you need support.',
    },
  ];

  return (
    <section id="why-us" className="py-32 bg-gradient-to-br from-[#1e3a8a] to-[#0f2557] text-white overflow-hidden relative">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:4rem_4rem]" />
      
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="text-[#14b8a6] font-semibold text-sm tracking-wider uppercase mb-4">
            Why Partner With Us
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold mb-6">
            Built for Healthcare Excellence
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            We combine cutting-edge technology with human expertise to deliver
            revenue cycle management that actually works.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ delay: index * 0.15, duration: 0.6 }}
                whileHover={{ scale: 1.02 }}
              >
                <Card className="bg-white/5 backdrop-blur-sm border-white/10 hover:bg-white/10 transition-all duration-300 h-full hover:shadow-2xl hover:shadow-[#14b8a6]/10">
                  <CardContent className="p-10">
                    <motion.div
                      whileHover={{ scale: 1.1, rotate: 5 }}
                      transition={{ duration: 0.3 }}
                      className="w-16 h-16 rounded-2xl bg-[#14b8a6]/20 flex items-center justify-center mb-6"
                    >
                      <Icon size={32} className="text-[#14b8a6]" />
                    </motion.div>
                    <h3 className="text-2xl font-bold mb-4">{reason.title}</h3>
                    <p className="text-slate-300 leading-relaxed text-lg">
                      {reason.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
